import {Component, Input, OnDestroy, ViewEncapsulation} from '@angular/core';
import {EvkExpedienteModel} from '../../../../../../../expediente/models/evk-expediente.model';
import {FormBuilder, FormGroup} from "@angular/forms";
import {CatalogosService} from "../../../../../../../expediente/services/catalogos.service";
import * as _ from "lodash";
import {EvkSeccionConfigModel} from "../../../../../../../expediente/models/evk-seccion-config.model";
import {Punto} from "../../../evk-mapas/mapas/modelos/Punto";

@Component({
    selector: 'lib-informacion-general',
    templateUrl: './informacion-general.component.html',
    styleUrls: ['./informacion-general.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class InformacionGeneralComponent implements OnDestroy {

    @Input() expediente: EvkExpedienteModel;
    @Input() sectionConfig: EvkSeccionConfigModel;
    @Input() readOnlyForm: boolean;
    @Input() form: FormGroup = new FormGroup({});

    @Input()
    descargaZipByFolio: boolean;
    @Input()
    skipByVersion: boolean;
    panelOpenState = false;

    constructor(
        public fb: FormBuilder,
        public catalogoService: CatalogosService,
    ) {

    }

    ngOnDestroy(): void {
    }

    findSeccion(nombre, expediente) {
        if (expediente && expediente.secciones && expediente.secciones.length > 0) {
            return _.get(expediente.secciones.find(seccion => seccion.origen === nombre), 'propiedades', '');
        }
        return null;
    }

    onDoneForm(value: Object) {
        if (value === true) {
            setTimeout(() => {
                this.form.patchValue(this.findSeccion(this.sectionConfig.nombre, this.expediente));
            }, 3000);

        }
    }

    getPointToMap() {
        let properties: any = this.findSeccion(this.sectionConfig.nombre, this.expediente);
        if (properties['lat'] && properties['lng']) {
            return new Punto(properties['lat'], properties['lng']);
        } else {
            return null;
        }
    }

}
